module.exports = __webpack_public_path__ + "static/media/cmt.261bdb55.svg";